<router-outlet *ngIf="authenticationChecked$ | async"></router-outlet>